import { Tipologia } from "./tipologia.model"

export interface CarrerasInterface {
  ciclo: Ciclo
  codigoArea: string
  area: string
  subarea: string
  orientacion: string
  orientacionOcupacional: string
  modalidad: string
  profesional: string
  codigoCarrera: string
  carrera: string
  comentario: string
  palabraClave: string
  tipoInstituto: string
}

export interface Ciclo extends Tipologia {}


export interface ListadoCarrerasDTO {
    total: number;
    data: CarrerasInterface[];
}


export class CarreraModel {
    carreraId: number = 0
    codigo: string = ''
    carreraUuid?:string= ''
    ciclo: Ciclo
    codigoArea: string = ''
    area: string =''
    subarea: string = 'N/A'
    orientacion: string = 'N/A'
    orientacionOcupacional: string = 'N/A'
    modalidad: string = 'N/A'
    profesional: string = ''
    codigoCarrera: string = ''
    carrera: string = ''
    comentario: string = ''
    palabraClave: string    = ''
    tipoInstituto: string    = ''
    orientacionSubareaAsignatura: string = 'N/A'

    constructor() {
    }
}


